export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/visitor/resources/components.js